import { SupportedLanguage } from '../generated/types';

export const APP_DISPLAY_NAME = 'WeezCrew';
export const APP_LOGO_URL = 'https://assets.recrewteer.com/logos/weezcrew.png';
export const APP_SUPPORT_EMAIL = 'weezcrew@weezevent.com';

export function appTermsUrl(language: SupportedLanguage) {
    if (language === SupportedLanguage.Fr) {
        return 'https://weezevent.com/fr/cgus/';
    } else if (language === SupportedLanguage.Nl) {
        return 'https://weezevent.com/nl/gebruiksvoorwaarden-diensten/';
    } else if (language === SupportedLanguage.Es) {
        return 'https://weezevent.com/es/cgus/';
    } else {
        return 'https://weezevent.com/en-gb/terms-of-use/';
    }
}
